<template>
  <v-container class="text-center">
    <h1>Sign In</h1>
    <div class="mb-10">
      Don’t have an account? <router-link :to="{name: 'auth.signup'}">Get started!</router-link>
    </div>

    <v-form
      ref="form"
      lazy-validation
      @submit="submit"
    >
      <v-text-field
        v-model="email"
        label="E-mail"
        type="email"
        required
        outlined
        :disabled="loading"
        :error-messages="emailErrors"
      ></v-text-field>

      <v-text-field
        v-model="pass"
        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPass ? 'text' : 'password'"
        label="Password"
        required
        outlined
        :disabled="loading"
        @click:append="showPass = !showPass"
        :error-messages="passErrors"
      ></v-text-field>

      <v-btn color="primary"
             class="mb-5 w-100 sh-green"
             x-large
             :loading="loading"
             @click="submit">
        Sign In
      </v-btn>

      <router-link :to="{name: 'auth.reset'}">Forgot password?</router-link>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, minLength, email, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'SignIn',

  mixins: [validationMixin],
  validations: {
    email: { required, email },
    pass: { required, minLength: minLength(6), maxLength: maxLength(16) }
  },
  computed: {
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid e-mail')
      !this.$v.email.required && errors.push('E-mail is required')
      return errors
    },
    passErrors () {
      const errors = []
      if (!this.$v.pass.$dirty) return errors
      !this.$v.pass.minLength && errors.push('Password must be more than 6 characters long')
      !this.$v.pass.maxLength && errors.push('Password must be less than 16 characters long')
      !this.$v.pass.required && errors.push('Password is required')
      this.invalidLogin && errors.push('Invalid email or password')
      return errors
    }
  },

  data: () => ({
    showPass: false,
    email: '',
    pass: '',
    loading: false,
    invalidLogin: false
  }),
  methods: {
    ...mapActions({
      signIn: 'auth/SIGNIN'
    }),
    submit () {
      this.invalidLogin = false
      this.loading = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$api.auth.signIn({
          email: this.email,
          password: this.pass
        }).then(({ data }) => {
          this.signIn(data).then(() => {
            this.$router.push({ name: 'cpanel.dashboard' })
          })
        }).catch(() => {
          this.invalidLogin = true
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
